import { useEffect, useState } from 'preact/hooks';
import { app } from './controller.js';

/** Re-render when the controller changes. */
export function useApp() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const off = app.subscribe(() => setTick((n) => n + 1));
    // the app may have changed between the first render and this effect (init() can finish first
    // when the device store already exists): render once more so nothing emitted is missed
    setTick((n) => n + 1);
    return off;
  }, []);
  return app;
}

/** Hash routes: #/, #/register, #/patient/<id>, #/patient/<id>/edit, #/patient/<id>/visit/<pack>,
 *  #/followup, #/numbers, #/hmis, #/settings, #/failed */
const parseHash = () => (location.hash.replace(/^#\/?/, '') || '').split('/').filter(Boolean);

export function useRoute(): string[] {
  const [r, setR] = useState(parseHash);
  useEffect(() => {
    const on = () => setR(parseHash());
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return r;
}

export const go = (path: string) => {
  location.hash = `#/${path}`;
};
